import api from '@/lib/api'
import moment from 'moment'
import { Notyf } from 'notyf'
const notyf = new Notyf()
export default {
  namespaced: true,
  state: {
    loading: true,
    getting: false,
    saving: false,
    list: [],
    keyword: '',
    daterange: {
      startDate: new Date(),
      endDate: new Date(new Date().setDate(new Date().getDate() + 7))
    },
    selected_game: null,
    selected_games: [],
    form: {
      id: 0,
      name: '',
      start_date: '',
      end_date: '',
      logo: null,
      logo_url: null,
      description: '',
      awards: [],
      games: [],
      is_daily: false,
      score_rules: [],
      rules: {
        and: [],
        or: []
      }
    },
    operators: [
      { name: 'greater_than', value: '>' },
      { name: 'less_than', value: '<' },
      { name: 'equal_or_greater_than', value: '>=' },
      { name: 'equal_or_less_than', value: '<=' },
      { name: 'is', value: '==' },
      { name: 'is_not', value: '!=' }
    ],
    scores: [
      { name: 'profit', value: 'profit' },
      { name: 'outfit', value: 'outfit' }
    ],
    fields: [
      { name: 'spin_or_card', value: 'spin_or_card' },
      { name: 'score', value: 'score' }
    ],
    awardObject: {
      min: '',
      max: '',
      award: ''
    },
    andOrObject: {
      field: '',
      operator: '',
      value: ''
    },
    scoreObject: {
      field: '',
      operator: '',
      value: ''
    },
    addEdit: false
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload
    },
    setGetting(state, payload) {
      state.getting = payload
    },
    setSaving(state, payload) {
      state.saving = payload
    },
    resetForm(state) {
      state.selected_game = null
      state.selected_games = []
      state.daterange = {
        startDate: new Date(),
        endDate: new Date(new Date().setDate(new Date().getDate() + 7))
      }
      state.form = {
        id: 0,
        name: '',
        start_date: '',
        end_date: '',
        logo: null,
        logo_url: null,
        description: '',
        is_daily: false,
        score_rules: [],
        awards: [],
        games: [],
        rules: {
          and: [],
          or: []
        }
      }
    },
    setList(state, tournaments) {
      state.list = tournaments
    },
    setKeyword(state, keyword) {
      state.keyword = keyword
    },
    setAddEdit(state, payload) {
      state.addEdit = payload
    },
    addSelectedGame(state, game) {
      state.selected_games.push(game)
      state.form.games.push(game.id)
      state.selected_game = null
    },
    removeGame(state, game_id) {
      state.selected_games = state.selected_games.filter(
        game => game.id != game_id
      )
      state.form.games = state.form.games.filter(id => id != game_id)
    },
    addItem(state, payload) {
      state.form.rules[payload].push({
        ...state.andOrObject,
        id: state.form.rules[payload].length
      })
    },
    removeItem(state, { type, item_id }) {
      state.form.rules[type] = state.form.rules[type].filter(
        item => item.id != item_id
      )
    },
    addScore(state, payload) {
      state.form.score_rules.push({
        ...state.scoreObject,
        id: state.form.score_rules.length
      })
    },
    removeScore(state, { item_id }) {
      state.form.score_rules = state.form.score_rules.filter(
        item => item.id != item_id
      )
    }
  },
  actions: {
    addScore({ commit }, payload) {
      commit('addScore', payload)
    },
    removeScore({ commit }, { type, item_id }) {
      commit('removeScore', { type, item_id })
    },
    addItem({ commit }, payload) {
      commit('addItem', payload)
    },
    removeItem({ commit }, { type, item_id }) {
      commit('removeItem', { type, item_id })
    },
    onGameSelect({ commit, rootState }, game_id) {
      const game = rootState.game.list.find(game => game.id == game_id)
      commit('addSelectedGame', game)
    },
    removeGame({ commit }, game_id) {
      commit('removeGame', game_id)
    },
    setAddEdit({ commit }, payload) {
      if (!payload) commit('resetForm')
      commit('setAddEdit', payload)
    },
    async addTournament({ commit, dispatch, state }, site_id) {
      commit('setSaving', true)
      let postData = {
        ...state.form,
        start_date: moment(state.daterange.startDate).format('YYYY-MM-DD'),
        end_date: moment(state.daterange.endDate).format('YYYY-MM-DD')
      }

      delete postData.id
      delete postData.logo_url

      postData.rules.and = postData.rules.and
        .filter(item => item.field && item.operator && item.value)
        .map(item => {
          return {
            field: item.field,
            operator: item.operator,
            value: item.value
          }
        })

      postData.rules.or = postData.rules.or
        .filter(item => item.field && item.operator && item.value)
        .map(item => {
          return {
            field: item.field,
            operator: item.operator,
            value: item.value
          }
        })

      postData.awards = postData.awards.map(award => {
        return {
          range: `${award.min}-${award.max}`,
          award: award.award
        }
      })

      postData.rules = JSON.stringify(postData.rules)
      postData.score_rules = JSON.stringify(postData.score_rules)

      let contentType = 'application/json'
      if (postData.logo && postData.logo.type) {
        contentType = 'multipart/form-data'
        let formData = new FormData()
        Object.entries(postData).forEach(([key, value]) => {
          if (key === 'logo') return
          if (key === 'games') {
            value.forEach(game => {
              formData.append(`tournament[${key}][]`, game)
            })
            return
          }
          formData.append(`tournament[${key}]`, value)
        })
        formData.append('tournament[logo]', postData.logo)
        postData = formData
      }

      try {
        const response = await api.post(
          `sites/${site_id}/tournaments`,
          postData,
          {
            headers: {
              'Content-Type': contentType
            }
          }
        )
        commit('setAddEdit', false)
        commit('resetForm')
        dispatch('getTournaments', site_id)
        commit('setSaving', false)
        notyf.success('Tournament added successfully')
      } catch (error) {
        commit('setSaving', false)
        notyf.error(error.message)
      }
    },
    async getTournaments({ commit }, site_id) {
      commit('setLoading', true)
      try {
        const response = await api.get(`/sites/${site_id}/tournaments`)
        commit('setList', response.data)
        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        notyf.error(error.message)
      }
    },
    async getTournament({ commit }, { site_id, tour_id }) {
      try {
        const response = await api.get(
          `/sites/${site_id}/tournaments/${tour_id}`
        )
        return response.data
      } catch (error) {
        notyf.error(error.message)
      }
    },
    async saveTournament({ commit, dispatch, state }, site_id) {
      commit('setSaving', true)
      let postData = {
        ...state.form,
        start_date: moment(state.daterange.startDate).toISOString(),
        end_date: moment(state.daterange.endDate).toISOString()
      }

      delete postData.id
      delete postData.logo_url

      postData.rules.and = postData.rules.and
        .filter(item => item.field && item.operator && item.value)
        .map(item => {
          return {
            field: item.field,
            operator: item.operator,
            value: item.value
          }
        })

      postData.rules.or = postData.rules.or
        .filter(item => item.field && item.operator && item.value)
        .map(item => {
          return {
            field: item.field,
            operator: item.operator,
            value: item.value
          }
        })

      postData.awards = postData.awards.filter(
        award => award.min && award.max && award.award
      )

      postData.rules = JSON.stringify(postData.rules)
      postData.score_rules = JSON.stringify(postData.score_rules)

      postData.awards = JSON.stringify(
        postData.awards.map(award => {
          return {
            range: `${award.min}-${award.max}`,
            award: award.award
          }
        })
      )

      let contentType = 'application/json'
      if (postData.logo && postData.logo.type) {
        contentType = 'multipart/form-data'
        let formData = new FormData()
        Object.entries(postData).forEach(([key, value]) => {
          if (key === 'logo') return
          if (key === 'games') {
            value.forEach(game => {
              formData.append(`tournament[${key}][]`, game)
            })
            return
          }
          formData.append(`tournament[${key}]`, value)
        })
        formData.append('tournament[logo]', postData.logo)
        postData = formData
      }

      try {
        const response = await api.put(
          `sites/${site_id}/tournaments/${state.form.id}`,
          postData,
          {
            headers: {
              'Content-Type': contentType
            }
          }
        )
        commit('setAddEdit', false)
        commit('resetForm')
        dispatch('getTournaments', site_id)
        commit('setSaving', false)
        notyf.success('Tournament updated successfully')
      } catch (error) {
        commit('setSaving', false)
        notyf.error(error.message)
      }
    },
    async editTournament(
      { commit, dispatch, state, rootState },
      { site_id, tour_id }
    ) {
      commit('setGetting', true)
      try {
        const tournament = await dispatch('getTournament', { site_id, tour_id })
        commit('setAddEdit', true)
        state.form.id = tournament.id
        state.form.name = tournament.name
        state.form.logo_url = tournament.logo_url
        state.daterange.startDate = new Date(tournament.start_date)
        state.daterange.endDate = new Date(tournament.end_date)
        state.form.description = tournament.description
        state.form.is_daily = tournament.is_daily
        state.form.awards = tournament.awards
          ? JSON.parse(tournament.awards).map(award => {
              return {
                min: award.range.split('-')[0],
                max: award.range.split('-')[1],
                award: award.award
              }
            })
          : []

        state.form.games = tournament.games.map(game_id => +game_id)
        state.selected_games = rootState.game.list.filter(game => {
          return tournament.games.map(game_id => +game_id).includes(+game.id)
        })
        state.form.rules = JSON.parse(tournament.rules)
        state.form.score_rules = JSON.parse(tournament.score_rules)
        commit('setGetting', false)
      } catch (error) {
        commit('setGetting', false)
        notyf.error(error.message)
      }
    },
    async deleteTournament({ commit, dispatch }, { site_id, tour_id }) {
      window.confirm('Are you sure you want to delete this tournament?')

      try {
        const response = await api.delete(
          `sites/${site_id}/tournaments/${tour_id}`
        )
        dispatch('getTournaments', site_id)
        notyf.success('Tournament deleted successfully')
      } catch (error) {
        notyf.error(error.message)
      }
    },
    addLogo({ commit, state }, event) {
      state.form.logo = event.target.files[0]
    },
    removeLogo({ commit, state }) {
      state.form.logo = null
      state.form.logo_url = null
    },
    addAward({ commit, state }) {
      state.form.awards.push({ ...state.awardObject })
    },
    removeAward({ commit, state }, index) {
      state.form.awards.splice(index, 1)
    }
  },
  getters: {
    tournaments: state => {
      let filtered = state.list
      if (state.keyword) {
        filtered = filtered.filter(tournament => {
          return tournament.name
            .toLowerCase()
            .includes(state.keyword.toLowerCase())
        })
      }
      return filtered
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tournament.js